import { STATUS_DONE_KEY } from '../../../../constants/constants';
import { updateDbProp } from '../../../../helpers/idb';
import {
  getPropLightList,
  getPropMetadata,
  isExclusiveProp,
} from '../../../../helpers/unityHelper';
import { selectProductNotReady } from '../../../../redux/slicers/admin/curatorSlicer';
import { getAppState } from '../../../../redux/store';

export const simplifyPropData = async (prop) => {
  // Load a placeholder cube for models with unready asset bundles during guest user login
  // For unready models, we set fileUrl to null, prompting Unity to load a default cube
  const productNotReady = selectProductNotReady(getAppState());
  const isUploadedNotReadyModel =
    productNotReady && prop?.is_user_model_uploaded && prop?.product_job_status !== STATUS_DONE_KEY;

  const propDbData = isUploadedNotReadyModel ? {} : await updateDbProp(prop);
  let fileUrl = isUploadedNotReadyModel ? null : propDbData.file || prop?.product_file;
  if (propDbData.is_windows_and_doors) {
    fileUrl = propDbData.file_window_door || prop.product_file_window_door;
  }
  const lightList = await getPropLightList(prop);

  return {
    id: Number(prop.id),
    propName: prop.name,
    locationUrl: fileUrl,
    roomLightDatas: lightList,
    main_asset_name: prop.main_asset_name,
    blender_id: prop.blender_id,
    isExclusiveProp: isExclusiveProp(prop),
    isRoofProp: prop?.is_roof_prop,
    ...(prop?.prop_data_user_file ? { modelType: 'UserImportModel' } : {}),
    ...getPropMetadata(prop),
  };
};
